import { create } from 'zustand'

type EventTopicsStore = {
  subscribedTopics: Map<string, boolean>
  addTopic: (topic: string) => void
  removeTopic: (topic: string) => void
}

const useEventTopicsStore = create<EventTopicsStore>(set => ({
  subscribedTopics: new Map<string, boolean>(),

  addTopic: (topic: string) =>
    set(state => {
      const newMap = new Map(state.subscribedTopics)
      newMap.set(topic, true)
      return { subscribedTopics: newMap }
    }),

  removeTopic: (topic: string) =>
    set(state => {
      const newMap = new Map(state.subscribedTopics)
      newMap.delete(topic)
      return { subscribedTopics: newMap }
    }),
}))

export default useEventTopicsStore
